import React from 'react'

const Info = () => {
  return (
    <div className="about__info grid">
        <div className="about__box">
        <i class="bx bx-award about__icon"></i>
            <h3 className="about__title">Experience</h3>
            <span className="about__subtitle">Student</span>
        </div>

        <div className="about__box">
        <i class="bx bx-briefcase-alt about__icon"></i>
            <h3 className="about__title">Completed</h3>
            <span className="about__subtitle">10+ Projects</span>
        </div>

        <div className="about__box">
        <i class="uil uil-graduation-cap about__icon"></i>
        {/* <i className="bx bx-engineering-icon about__icon"></i> */}
            <h3 className="about__title">Student</h3>
            <span className="about__subtitle">3rd Yr B.Tech.</span>
        </div>
    </div>
  )
}

export default Info